// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Nk-z","tupacHeader":"Ok-z","tupacHeader2":"Pk-z","tupacMenu":"Qk-z","tupacMenu2":"Rk-z","tupacMain":"Sk-z","tupacMain2":"Tk-z"};